module.exports = __webpack_public_path__ + "img/partner_4.0c3b84a0.png";